import React, { useEffect, useRef, useState } from 'react';
import './ProjectButton.css';
import { ReactComponent as ArrowRightIcon } from '../../images/arrow-right.svg'

type ProjectButtonProps = {
    link: string;
    mainColor: string;
    buttonBackgroundColor?: string;
    buttonTextColor?: string;
    buttonText?: string;
    type: "github" | "website";
}

function ProjectButton(props: ProjectButtonProps) {
    const [buttonText, setButtonText] = useState("")
    const buttonRef = useRef(null)

    useEffect(() => {
        if (props.type === "github") {
            setButtonText("Github")
        }
        else if (props.buttonText) {
            setButtonText(props.buttonText)
        }
        else {
            setButtonText("Website")
        }
    }, [props.buttonText, props.type])

    useEffect(() => {
        // Initialize IntersectionObserver to animate on scroll
        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add("show")
                }
            })
        })

        // Observe elements that should be animated
        if (buttonRef.current) observer.observe(buttonRef.current)
    }, [])

    const buttonStyles = {
        backgroundColor: props.buttonBackgroundColor ? props.buttonBackgroundColor : props.mainColor,
        color: props.buttonTextColor ? props.buttonTextColor : "white",
        right: props.type === "website" ? "195px" : "40px"
    }

    return (
        <a href={props.link} target="_blank" rel="noreferrer">
            <button className={`project-link ${props.type === "website" ? "website-link" : ""}`} style={buttonStyles} ref={buttonRef}>
                <span className='project-link-text'>{buttonText}</span>
                <ArrowRightIcon fill={props.buttonTextColor ? props.buttonTextColor : "white"} />
            </button>
        </a>
    );
}

export default ProjectButton;